// Live-verified or spec strings: compat-extension-cli.md 5.2 (Manage API keys) and settings.md 19 (Webhooks).
export const s = {
  userTitle: "User",
  webhooksTitle: "Webhooks",

  preferences: "Preferences",
  advanced: "Advanced",
  webhooks: "Webhooks",
  breadcrumb: "Breadcrumb",

  // Manage API keys
  manageApiKeys: "Manage API keys",
  generateNew: "Generate new",
  apiKeysCard: "API Keys",
  colName: "Name",
  colCreated: "Created",
  colKey: "Key",
  noKeys: "No API keys yet",
  keyLimit: "You've reached the maximum number of API keys",
  keyActions: (name: string) => `Actions for ${name}`,
  rename: "Rename",
  delete: "Delete",
  dash: "-",
  generateTitle: "Generate API key",
  nameLabel: "Name",
  namePlaceholder: "Enter name",
  nameRequired: "Name is required",
  cancel: "Cancel",
  generate: "Generate",
  copy: "Copy",
  copied: "Copied to clipboard",
  close: "Close",
  copyWarning: "Make sure to copy your API key now. You won't be able to see it again.",
  apiKeyLabel: "API key",
  renameTitle: "Rename API key",
  save: "Save",
  deleteKeyTitle: "Delete API key",
  deleteKeyBody:
    "Are you sure you want to delete this API key? Apps and integrations using it will stop working immediately.",
  keyDeleted: "API key deleted",
  keyRenamed: "API key renamed",

  // Webhooks list
  createNew: "Create new",
  outOf: (n: number, limit: number) => `${n} out of ${limit}`,
  yourWebhooks: "Your webhooks",
  othersWebhooks: "Other's webhooks",
  noWebhooks: "No webhooks yet",
  onlyAdmins: "Only admins have access to this.",
  active: "Active",
  disabled: "Disabled",
  details: "Details",
  edit: "Edit",
  webhookActions: (name: string) => `Actions for ${name}`,
  disabledReason: {
    DELIVERY_FAILURES: "Webhook disabled after too many failed attempts.",
    PERMISSIONS_LOST: "Only workspace admins can have active webhooks.",
    PLAN_DOWNGRADE: "Webhook disabled after too many failed attempts.",
  } as Record<string, string>,
  triggerMe: "me",
  triggerEveryone: "everyone",
  triggerSelected: "selected",
  eventWithTrigger: (label: string, trigger: string) => `${label} (${trigger})`,

  // Create / edit modal
  createTitle: (ws: string) => `Create webhook on ${ws}`,
  editTitle: (ws: string) => `Edit webhook on ${ws}`,
  webhookName: "Name",
  webhookNamePlaceholder: "Enter webhook name",
  endpointUrl: "Endpoint URL",
  endpointPlaceholder: "https://example.com/endpoint",
  event: "Event",
  selectEvent: "Select event...",
  searchEvents: "Search events",
  trigger: "Trigger source",
  anyone: "Anyone",
  me: "Me",
  signingSecret: "Signing secret",
  copySecret: "Copy signing secret",
  showSecret: "Show signing secret",
  resetSecret: "Reset signing secret",
  resetSecretTitle: "Reset signing secret",
  resetSecretBody: "The current signing secret stops working immediately. Continue?",
  reset: "Reset",
  secretChanged: "Signing secret changed",
  create: "Create",
  nameInvalid: "Name must be between 2 and 30 characters.",
  urlInvalid: "Enter a valid URL.",
  eventRequired: "Event must be selected.",
  created: "Webhook created.",
  updated: "Webhook updated.",
  createFailed: "Create webhook failed.",
  limitReached: "Limit is reached.",
  deleteWebhookTitle: "Delete webhook",
  deleteWebhookBody: (name: string, url: string) => `You will delete ${name} and it won’t be sent to the ${url}.`,
  webhookDeleted: "Webhook deleted.",

  // Details
  sendTest: "Send test",
  testSent: "Test sent.",
  testFailed: "Send test failed.",
  logsRetention: "Logs older than 7 days are deleted",
  showAll: (n: number) => `Show all (${n})`,
  succeeded: "Succeeded",
  failed: "Failed",
  retrying: "Retrying",
  succeededCount: (n: number) => `Succeeded (${n})`,
  failedCount: (n: number) => `Failed (${n})`,
  attemptsCard: "Webhook attempts",
  attemptTime: "Attempt time",
  status: "Status",
  resend: "Resend",
  resendOk: "Resend successful.",
  resendFailed: "Resend failed.",
  expand: "Show details",
  collapse: "Hide details",
  requestToEndpoint: "Request to your endpoint",
  httpsStatus: "Https status",
  response: "Response",
  noResponseBody: "No response body",
  noAttempts: "No attempts yet",
  filterLabel: "Filter attempts",
  itemsPerPage: "Items per page",
  range: (from: number, to: number, total: number) => `${from}-${to} of ${total}`,
  previousPage: "Previous page",
  nextPage: "Next page",
  notFound: "Webhook not found",
  loadFailed: "Something went wrong. Please try again.",
} as const;
